'use strict'
// Template version: 1.3.1
// see http://vuejs-templates.github.io/webpack for documentation.

const path = require('path')
const urlHeader = 'test.';  //测试环境
// const urlHeader = '';   //线上
const version = 'v361';
module.exports = {
  dev: {
    env: require('./dev.env'),
    host: 'cgf.cwhisky.com',
    version: version,
    port: 8081,
    autoOpenBrowser: false,
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    LocalService: urlHeader,
    proxyTable: {
      '/api/': {
        target: 'http://'+urlHeader+'wap.cwhisky.com/' + version + '/api/',
        changeOrigin: true,
        pathRewrite: { //需要rewrite重写的, 如果在服务器端做了处理则可以不要这段
          '^/api/': ''
        }
      },
      '/core/': {
        target: 'http://'+urlHeader+'wap.cwhisky.com/' + version + '/core/',
        changeOrigin: true,
        pathRewrite: { //需要rewrite重写的, 如果在服务器端做了处理则可以不要这段
          '^/core/': ''
        }
      },
      '/dbcenter/': {
        target: 'http://'+urlHeader+'dbcenter.cwhisky.com/dbcenter/',
        changeOrigin: true,
        pathRewrite: { //需要rewrite重写的, 如果在服务器端做了处理则可以不要这段
          '^/dbcenter/': ''
        }
      },
      '/cwhisky-jp-app-api/': {
        target: 'https://'+urlHeader+'wap.cwhisky.com/' + version + '/cwhisky-jp-app-api/',
        changeOrigin: true,
        pathRewrite: { //需要rewrite重写的, 如果在服务器端做了处理则可以不要这段
          '^/cwhisky-jp-app-api/': ''
        }
      },
      //运营平台
      '/cwhisky-jp-opr-api/': {
        target: 'http://' + urlHeader + 'opr.cwhisky.com/cwhisky-jp-opr-api/',
        changeOrigin: true,
        pathRewrite: { //需要rewrite重写的, 如果在服务器端做了处理则可以不要这段
          '^/cwhisky-jp-opr-api/': ''
        }
      }
    },
    cssSourceMap: false
  },

  build: {
    env: require('./prod.env'),
    index: path.resolve(__dirname, '../dist/index.html'),
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',
    assetsPublicPath: './',
    productionSourceMap: true,
    devtool: '#source-map',
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],
    bundleAnalyzerReport: process.env.npm_config_report
  }
}



//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = FhoZ
// module chunks = 177